// @flow
import React from 'react';
import Console from '../../lib/debug';

type Props = {
    icon?: React.ReactNode,
    title?: string,
    text: string,
    children?: any
};

const EmptyState = ({ icon, title, text, children }: Props) => {
    Console.render('EmptyState');
    return (
        <div className="empty-state layout-align-center-center layout-column">
            {icon && <span>{icon}</span>}
            <span className="es-title">{title}</span>
            <span>{text}</span>
            {children}
        </div>
    );
};

export default EmptyState;

EmptyState.defaultProps = {
    icon: null,
    title: null,
    children: null
};



// WEBPACK FOOTER //
// ./src/view/common/EmptyState.jsx